import { createGlobalStyle } from 'styled-components';

export const GlobalFormsStyled = createGlobalStyle`
    .form-label {
        font-size: var(--font-size-sm);
        font-weight: 400;
        color: var(--text-color-secondary);
        margin-bottom: var(--space-2);
    }

    .form-control,
    .form-select {
        box-sizing: border-box;
        height: var(--control-height);
        min-height: var(--control-height);
        color: var(--color-white);
        background-color: var(--app-bg-color);
        border: 1px solid var(--color-main);
        border-radius: var(--radius-md);
        padding: 0 16px;
        font-size: var(--font-size-md);
        line-height: 1.2;

        &:hover {
            color: var(--color-white);
            border-color: var(--color-main);
        }

        &:focus {
            outline: 0;
            color: var(--color-white);
            background-color: var(--app-bg-color);
            border-color: var(--color-main);
            box-shadow: 0 0 0 0.2rem rgba(255, 221, 60, 0.2);
        }

        &:disabled,
        &[readonly] {
            color: var(--text-color-secondary);
            background-color: var(--app-bg-color);
            opacity: 0.8;
        }

        &::placeholder {
            color: var(--color-white-60);
        }

        &:-webkit-autofill,
        &:-webkit-autofill:focus {
            transition: background-color 600000s 0s, color 600000s 0s;
        }
    }

    .form-control-sm,
    .form-select-sm {
        height: var(--control-height-sm);
        min-height: var(--control-height-sm);
        padding: 0 12px;
        font-size: var(--font-size-sm);
    }

    .form-control-lg,
    .form-select-lg {
        height: var(--control-height-lg);
        min-height: var(--control-height-lg);
        padding: 0 20px;
        font-size: var(--font-size-base);
    }

    textarea.form-control,
    textarea.form-control-sm,
    textarea.form-control-lg {
        height: auto;
        min-height: 96px;
        padding: 12px 16px;
        line-height: 1.4;
        resize: vertical;
    }

    .form-hint,
    .form-text {
        display: block;
        margin-top: 6px;
        font-size: var(--font-size-xs);
        color: var(--text-color-secondary);
    }

    .form-check {
        min-height: 24px;
        padding-left: 36px;

        label {
            color: var(--text-color-secondary);
        }
    }

    .form-check .form-check-input {
        margin-left: -36px;
    }

    .form-check-input {
        width: 24px;
        height: 24px;
        margin-top: 0;
        margin-right: 0;
    }

    .form-check-input[type=checkbox] {
        border-radius: var(--radius-sm);
        background-color: transparent;
        border: 1px solid var(--color-main);
        color: var(--text-color-dark);

        &:hover {
            border-color: var(--color-accent);
        }

        &:checked {
            background-color: var(--color-accent);
            border-color: var(--color-accent);
            background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'%3e%3cpath fill='none' stroke='%230A0A10' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='M6 10l3 3l6-6'/%3e%3c/svg%3e");

            &:hover {
                background-color: var(--color-yellow-light);
                border-color: var(--color-yellow-light);
            }
        }
    }

    .form-select {
        appearance: none;
        padding-right: 40px;
        background-color: var(--app-bg-color);
        background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='%23A3A6CC' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='m2 5 6 6 6-6'/%3e%3c/svg%3e");
        background-repeat: no-repeat;
        background-position: right 12px center;
        background-size: 16px 12px;
        cursor: pointer;

        &:focus {
            background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='%23A3A6CC' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='m2 5 6 6 6-6'/%3e%3c/svg%3e");
            background-repeat: no-repeat;
            background-position: right 12px center;
            background-size: 16px 12px;
        }

        &:disabled {
            background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='%23A3A6CC' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='m2 5 6 6 6-6'/%3e%3c/svg%3e");
            background-repeat: no-repeat;
            background-position: right 12px center;
            background-size: 16px 12px;
            cursor: not-allowed;
        }
    }

    /* Partner-cabinet form extras */
    .form-valid-hint {
        display: none;
        color: var(--color-negative);
    }

    .form-control:not(:placeholder-shown):not(:focus):invalid {
        + .form-valid-hint {
            display: block;
        }
    }

    .form-control:not(:placeholder-shown):not(:focus):invalid,
    .form-control.is-invalid,
    .was-validated .form-control:invalid {
        background-image: none;
        border-color: var(--color-negative);
    }

    .form-check .form-check-input[type=radio] {
        background-color: transparent;
        border: 1px solid var(--color-main);

        &:hover {
            border-color: var(--color-accent);
        }

        &:checked {
            background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='1.8' fill='%2342456C'/%3e%3c/svg%3e");
            background-color: var(--color-accent);
            border-color: var(--color-accent);
        }
    }

    .form-switch {
        .form-check-input[type=checkbox] {
            width: 48px;
            height: 28px;
            margin-top: 0;
            margin-right: 0;
            background-color: var(--color-purple-highlight);
            border: none;
            border-radius: var(--radius-md);
            box-shadow: none;
            background-image: url('/assets/icons/switch-circle.svg');
            background-repeat: no-repeat;

            &:checked {
                background-color: var(--color-accent);
            }
        }

        .form-label {
            margin-bottom: 0;
        }
    }
`;
